import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Topmenuright() {
  return (
    <nav class="navbar navbar-expand-lg">

      <div class="container">

        <button data-mdb-button-init class="navbar-toggler px-0" type="button" data-mdb-collapse-init
          data-mdb-target="#navbarExampleOnHover" aria-controls="navbarExampleOnHover" aria-expanded="false"
          aria-label="Toggle navigation">
        </button>

        <div class="collapse navbar-collapse" id="navbarExampleOnHover">

          <ul class="navbar-nav">

            <li class="nav-item">
            <Link className='nav-link' to='/dashboard'><span class="blink-live new">new</span>Exhibitor Login</Link>
            </li>            

            {/* <li class="nav-item">
            <Link className='nav-link' to='/login'>Visitor</Link>
            </li>
             */}
             
            <li class="nav-item">
            <Link className='nav-link' to='/sponsership'>Sponsorship</Link>
            </li>

            <li class="nav-item">
            <Link className='nav-link' to='/gallery'>Gallery</Link>
            </li>

          </ul>

        </div>

      </div>

    </nav>
  )

}

export default Topmenuright;
